// extracted by mini-css-extract-plugin
export default {"img":"TpUq2UhPATDQPWer5fE3Pg=="};